module.exports = __webpack_public_path__ + "img/Ma.Maritime.Quaywalls.Combiwall.Concrete.5a554d2e.png";